import React from 'react';
import PropTypes from 'prop-types';

// Stage 3.2 (Enterprise Design Foundation & Layout Standardization): a single, reusable inline
// alert for success/warning/info messaging — the .ent-danger-banner class (Sprint 2.4B, themes.scss)
// already covers the "error" tone; this component fills the missing three tones via the new
// .ent-alert-success/-warning/-info classes and reuses .ent-danger-banner as-is for "error" rather
// than duplicating it. Purely presentational — no existing page consumes this yet.
const Alert = ({ type, title, children }) => {
  if (type === 'error') {
    return (
      <div className="ent-danger-banner">
        <div className="ent-danger-icon" aria-hidden="true">!</div>
        <div>
          {title && <div className="ent-danger-title">{title}</div>}
          <div className="ent-danger-description">{children}</div>
        </div>
      </div>
    );
  }

  return (
    // Phase C.7.4D-R2 (§3 Application Summary Note visual integration): added `ent-alert-body` as a
    // dedicated wrapper so the heading/body relationship (spacing, icon alignment) can be styled
    // without touching `.ent-card-header-text` itself — that class is shared with every Card header
    // across the app (Card.jsx), so all sizing/spacing changes for this "Note" heading are scoped
    // under `.ent-alert .ent-card-header-text` in CSS instead.
    <div className={`ent-alert ent-alert-${type}`} role="status">
      <div className="ent-alert-body">
        {title && <div className="ent-card-header-text ent-alert-title">{title}</div>}
        <div className="ent-helper-text">{children}</div>
      </div>
    </div>
  );
};

Alert.propTypes = {
  type: PropTypes.oneOf(['success', 'warning', 'error', 'info']).isRequired,
  title: PropTypes.node,
  children: PropTypes.node
};

export default Alert;
